import script from "./MenueAdminMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./MenueAdminMenu.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styles/sfc/components/sites/modules/MenueAdminMenu.css?vue&type=style&index=0&id=15457f8f&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15457f8f"]])

export default __exports__